import AdvancedSettingsType from "./AdvancedSettingsType.js";
var DEFAULTS = Object.freeze([[AdvancedSettingsType.FILTER_CONTROL_CHANGE_CLEARS_ALL_FILTERS, false], [AdvancedSettingsType.LINK_CHANGE_CLEARS_ALL_FILTERS, false]]);
export default {
  DEFAULTS
};
//# sourceMappingURL=AdvancedSettings.js.map